import React, { useRef } from "react";
import generatePDF from "react-to-pdf";
import { TermsAndConditionsPDF } from "./termsForPDF";

const UserPDF = ({
  name,
  email,
  termsAccepted,
  signature,
  ipAddress,
  timestamp,
}) => {
  const pdfRef = useRef();

  return (
    <div className="pdfMain">
      <div
        ref={pdfRef}
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "210mm", // A4 width for better formatting
          color: "black",
          padding: 20,
          backgroundColor: "#fff",
          pageBreakAfter: "always",
        }}
      >
        <h2>User Consents Summary</h2>
        <p>
          <strong>Name:</strong> {name}
        </p>
        <p>
          <strong>Email:</strong> {email}
        </p>
        <p>
          <strong>Terms Accepted:</strong> {termsAccepted ? "Yes" : "No"}
        </p>
        <p>
          <strong>Digital Signature:</strong> {signature}
        </p>
        {ipAddress && (
          <p>
            <strong>Ip Address:</strong> {ipAddress}
          </p>
        )}
        <p>
          <strong>Timestamp:</strong> {timestamp}
        </p>

        <TermsAndConditionsPDF />
      </div>
      <button
        onClick={() =>
          generatePDF(pdfRef, { filename: `consent(${email}).pdf` })
        }
      >
        Download PDF
      </button>
    </div>
  );
};

export default UserPDF;
